/* eslint-disable no-param-reassign */
/* eslint-disable object-curly-newline */
/* eslint-env jquery */

import { Component, registerComponent } from 'js/component.js';

const componentName = 'pdf-to-html-wizard';
export class PdfToHtmlWizard extends Component {
    elements = {
        selectedPdfPaths: this.element.querySelector(`.${componentName}__selected-pdf-paths`),
        convertButton: this.element.querySelector(`.${componentName}__convert-button`),
        closeButton: this.element.querySelector(`.${componentName}__close-button`),
        dialog: this.element.querySelector(`.${componentName}__dialog`),
        dialogContent: this.element.querySelector(`.${componentName}__dialog-content`),
        dialogContentResultsList: this.element.querySelector(`.${componentName}__dialog-content-results-list`),
        templateSelector: this.element.querySelector(`.${componentName}__template-selector-select`),
        templateSelectorContainer: this.element.querySelector(`.${componentName}__template-selector`),
        pixelPerfectCheckbox: this.element.querySelector(`.${componentName}__mode-checkbox-input`),
        semanticHtmlCheckbox: this.element.querySelector(`.${componentName}__semantic-html-checkbox-input`),
        semanticHtmlCheckboxContainer: this.element.querySelector(`.${componentName}__semantic-html-checkbox`),
    };

    state = {
        selectedPdfPaths: [],
        selectedTemplate: '',
        selectedMode: 'doc2page',
    };

    constants = {
        PDF_PAGE_PREFIX: '/content/rockwell-automation/global/en/pdf-pages/',
        APP: 'rockwell-automation',
    };

    handleConvert = async () => {
        this.elements.convertButton.disabled = true;
        this.elements.convertButton.textContent = 'Converting...';

        const conversionResults = [];
        const postBody = {
            sourceType: 'pdf',
            profileName: this.state.selectedTemplate,
            conversionMode: this.state.selectedMode,
        };
        const enableSemanticHtml = (!this.elements.semanticHtmlCheckboxContainer.classList.contains('hidden') && this.elements.semanticHtmlCheckbox.checked);
        if (enableSemanticHtml) {
            postBody.enableSemanticHtml = true;
        }
        if (this.state.selectedPdfPaths.length === 1) {
            const path = this.state.selectedPdfPaths[0];
            const targetPageTitleInput = document.getElementById(`page-title-${this.stringToHtmlPath(path)}`);
            const targetPagePath = targetPageTitleInput.value ? this.constants.PDF_PAGE_PREFIX + this.stringToHtmlPath(targetPageTitleInput.value) : this.constants.PDF_PAGE_PREFIX + this.stringToHtmlPath(path.substring(path.lastIndexOf('/') + 1).split('.')[0]);
            postBody.sourcePath = path;
            postBody.targetPath = targetPagePath;
            await this.postConversionJob(postBody, conversionResults, false);
        } else if (this.state.selectedPdfPaths.length > 1) {
            const jobData = [];
            for (const path of this.state.selectedPdfPaths) {
                const targetPageTitleInput = document.getElementById(`page-title-${this.stringToHtmlPath(path)}`);
                const targetPagePath = targetPageTitleInput.value ? this.constants.PDF_PAGE_PREFIX + this.stringToHtmlPath(targetPageTitleInput.value) : this.constants.PDF_PAGE_PREFIX + this.stringToHtmlPath(path.substring(path.lastIndexOf('/') + 1).split('.')[0]);
                jobData.push({
                    sourcePath: path,
                    targetPath: targetPagePath,
                });
            }
            postBody.jobs = jobData;
            await this.postConversionJob(postBody, conversionResults, true);
        }

        conversionResults.forEach(result => {
            const li = document.createElement('li');
            li.classList.add(`${componentName}__dialog-content-results-list-item`);
            li.classList.add(`${componentName}__dialog-content-results-list-item--${result.status}`);
            const span = document.createElement('span');
            span.textContent = result.path;
            span.classList.add(`${componentName}__dialog-content-results-list-item-path`);
            li.appendChild(span);
            if (result.status === 'failed') {
                const errorSpan = document.createElement('span');
                errorSpan.classList.add(`${componentName}__dialog-content-results-list-item-message`);
                errorSpan.textContent = result.error;
                li.appendChild(errorSpan);
            } else {
                const successSpan = document.createElement('span');
                successSpan.classList.add(`${componentName}__dialog-content-results-list-item-message`);
                successSpan.textContent = `Conversion job submitted successfully - Job ID: ${result.jobId}`;
                li.appendChild(successSpan);
            }
            this.elements.dialogContentResultsList.appendChild(li);
        });

        this.elements.dialog.showModal();

        this.elements.convertButton.disabled = false;
        this.elements.convertButton.textContent = 'Convert';
    };

    postConversionJob = async (postBody, conversionResults, isBatch = false) => {
        try {
            const response = await fetch('/bin/metaphora/doc2page/jobs.json', {
                method: 'POST',
                body: JSON.stringify(postBody),
            });
            if (response.ok) {
                const data = await response.json();
                if (data.success) {
                    if (isBatch) {
                        data.results.forEach(result => {
                            conversionResults.push({
                                status: result.success ? 'success' : 'failed',
                                jobId: result.id,
                                path: result.sourcePath,
                            });
                        });
                    } else {
                        conversionResults.push({
                            status: data.success ? 'success' : 'failed',
                            jobId: data.id,
                            path: postBody.sourcePath,
                        });
                    }
                } else {
                    conversionResults.push({
                        status: 'failed',
                        error: `Error submitting conversion job: ${data.errorMessage}`,
                    });
                }
            } else {
                conversionResults.push({
                    status: 'failed',
                    error: `Error submitting conversion job: ${response.status} ${response.statusText}`,
                });
            }
        } catch (error) {
            conversionResults.push({
                status: 'failed',
                error: `Error submitting conversion job: ${error}`,
            });
        }
    };

    handleClose = () => {
        if (document.referrer) {
            window.location.href = document.referrer;
        } else {
            window.location.href = '/aem/start.html';
        }
    };

    handleModeChange = () => {
        if (this.elements.pixelPerfectCheckbox.checked) {
            this.elements.convertButton.disabled = false;
            if (this.constants.APP === 'plex') {
                this.elements.templateSelectorContainer.classList.add('hidden');
            }
            this.elements.semanticHtmlCheckboxContainer.classList.remove('hidden');
        } else {
            this.elements.convertButton.disabled = this.elements.templateSelector.value === '';
            if (this.constants.APP === 'plex') {
                this.elements.templateSelectorContainer.classList.remove('hidden');
            }
            this.elements.semanticHtmlCheckboxContainer.classList.add('hidden');
        }
        this.state.selectedMode = this.elements.pixelPerfectCheckbox.checked ? 'doc2html' : 'doc2page';
    };

    handleTemplateChange = () => {
        if (this.elements.templateSelector.value === '') {
            this.elements.convertButton.disabled = true;
        } else {
            this.elements.convertButton.disabled = false;
        }
        this.state.selectedTemplate = this.elements.templateSelector.value;
    };

    stringToHtmlPath = (path) => {
        // convert to kebab-case
        let htmlPath = path;
        htmlPath = htmlPath.replace(/([A-Z])/g, '-$1').toLowerCase().replace(/^[-_]+/, '').replace(/[-_]+$/, '').replace(/[-_]+/g, '-').replace(/ /g, '-');
        return htmlPath;
    };

    initDom = () => {
        this.state.selectedPdfPaths = new URLSearchParams(window.location.search).get('items').split(',').map(path => decodeURIComponent(path));
        this.state.selectedPdfPaths.forEach(path => {
            const li = document.createElement('li');
            const span = document.createElement('span');
            span.textContent = path;
            const titleInput = document.createElement('input');
            titleInput.id = `page-title-${this.stringToHtmlPath(path)}`;
            titleInput.type = 'text';
            titleInput.value = path.substring(path.lastIndexOf('/') + 1).split('.')[0];
            titleInput.placeholder = ' ';
            const titleLabel = document.createElement('label');
            titleLabel.htmlFor = `page-title-${this.stringToHtmlPath(path)}`;
            titleLabel.textContent = 'Page Title (Optional)';
            const titleTooltip = document.createElement('div');
            titleTooltip.textContent = 'Renaming/Updating the page title will create a new file';
            titleTooltip.classList.add(`${componentName}__page-title-tooltip`);
            const titleInputContainer = document.createElement('div');
            titleInputContainer.appendChild(titleInput);
            titleInputContainer.appendChild(titleLabel);
            titleInputContainer.appendChild(titleTooltip);
            li.appendChild(span);
            li.appendChild(titleInputContainer);
            this.elements.selectedPdfPaths.appendChild(li);
        });

        if (this.state.selectedPdfPaths.length > 0 && this.state.selectedPdfPaths[0].startsWith('/content/dam/plex')) {
            this.constants.PDF_PAGE_PREFIX = '/content/plex/global/en/pdf-pages/';
            this.constants.APP = 'plex';
            if (this.state.selectedPdfPaths.length > 1) {
                this.elements.templateSelectorContainer.classList.add('hidden');
                this.elements.pixelPerfectCheckbox.checked = true;
                this.elements.pixelPerfectCheckbox.disabled = true;
                this.elements.convertButton.disabled = false;
                this.elements.semanticHtmlCheckboxContainer.classList.remove('hidden');
                this.state.selectedMode = 'doc2html';
            }
        } else {
            this.elements.templateSelectorContainer.classList.add('hidden');
            this.elements.pixelPerfectCheckbox.checked = false;
        }
    };

    addEventListeners = () => {
        this.elements.convertButton.addEventListener('click', this.handleConvert);
        this.elements.closeButton.addEventListener('click', this.handleClose);
        this.elements.dialogContent.querySelector('button').addEventListener('click', this.handleClose);
        this.elements.templateSelector.addEventListener('change', this.handleTemplateChange);
        this.elements.pixelPerfectCheckbox.addEventListener('change', this.handleModeChange);
    };

    /**
     * Initialize Component
     */
    init = () => {
        console.log('### PDF to HTML Wizard initialized');
        this.initDom();
        this.addEventListeners();
    };
}

registerComponent(`.${componentName}`, PdfToHtmlWizard);
